import type { DotToUnderscore } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/table-core';

import { checkMarkColumn } from '@/components/DataTable/Columns/checkMarkColumn';
import { simpleDateColumn } from '@/components/DataTable/Columns/simpleDateColumn';
import { simpleTextColumn } from '@/components/DataTable/Columns/simpleTextColumn';
import { AppUserColumn } from '@/features/app-user/components/AppUserColumn';

import type { AlertRowWithUser } from '../../-shared/types';
import { ActionsColumn } from '../../../-components/actions-column';
import { AppUserLastActivityColumn } from '../../../-components/app-user-last-activity-column';
import { AppUserPrimaryActionColumn } from '../../../-components/app-usr-primary-action-column';
import IntegratedAppColumn from '../../../-components/integrated-app-column';

type Row = AlertRowWithUser;

export const ColumnKey = {
  appUser: 'user',
  displayName: 'user.displayName',
  app: 'software',
  actualRoleName: 'user.actualRoleName',
  statusName: 'user.statusName',
  lastSignedInAt: 'user.lastSignedInAt',
  configuredMfa: 'user.configuredMfa',
  createdAt: 'user.createdAt',
} as const;

export const SortableColumnKey = [
  ColumnKey.appUser,
  ColumnKey.app,
  'user_actualRoleName',
  'user_statusName',
  'user_lastSignedInAt',
  'user_createdAt',
] as const satisfies DotToUnderscore<
  (typeof ColumnKey)[keyof typeof ColumnKey]
>[];

export function useSoftwareAlertsNoWorkerColumns(): ColumnDef<Row>[] {
  return [
    AppUserColumn({
      i18nKey: 'appUser',
      minWidth: '360px',
      maxWidth: '400px',
    }),
    // どうせないので表示しない
    // PersonColumn
    // 他のアラートには存在しないが、不明なアカウント一覧のため表示する
    simpleTextColumn(ColumnKey.displayName, {
      i18nKey: 'displayName',
    }),
    IntegratedAppColumn(ColumnKey.app, {}),
    simpleTextColumn(ColumnKey.actualRoleName, {
      i18nKey: 'appUserRole',
      sortable: true,
    }),
    simpleTextColumn(ColumnKey.statusName, {
      i18nKey: 'status',
      sortable: true,
    }),
    AppUserLastActivityColumn(ColumnKey.lastSignedInAt, {
      i18nKey: 'lastActivity',
      minWidth: '150px',
      activeAccessorFn: (row) => row.user.isActive,
    }),
    checkMarkColumn(ColumnKey.configuredMfa, {
      i18nKey: 'configuredMfa',
      sortable: false,
    }),
    simpleDateColumn(ColumnKey.createdAt, 'dateTime', {
      i18nKey: 'createdOn',
      sortable: true,
    }),
    AppUserPrimaryActionColumn(),
    ActionsColumn(),
  ];
}
